import * as React from 'react';

import './ConfigurationSwitchViewDetail.scss';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { requestAPIActions } from 'loopback-react-request';

export interface ConfigurationSwitchViewDetailProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export interface ConfigurationSwitchViewDetailState {
  show2d: boolean;
}

export class ConfigurationSwitchViewDetailPartial extends React.Component<ConfigurationSwitchViewDetailProps, ConfigurationSwitchViewDetailState> {
  constructor(props: ConfigurationSwitchViewDetailProps) {
    super(props);
    this.state = {
      show2d: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      show2d: this.show2d,
    });
  }

  componentDidUpdate(prevProps: ConfigurationSwitchViewDetailProps) {
    const conf = this.configuration;
    const prevConf = prevProps.configuration.result;

    if ((conf && conf.updated_at) !== (prevConf && prevConf.updated_at)) {
      if ((conf && conf.show2d) === this.state.show2d) {
        return;
      }
      this.setState({
        show2d: this.show2d,
      });
    }
  }

  public render() {
    return (
      <div className="partial-configuration-switch-view-detail">
        <div className="left mr-2">3D</div>
        <div className="switch">
            <input 
              checked={this.state.show2d}
              className="switch__input"
              id="switchCheckbox1"
              name="show2d"
              onChange={this.handleChange}
              type="checkbox"
            />
            <label aria-hidden="true" className="switch__label" htmlFor="switchCheckbox1">On</label>
            <div aria-hidden="true" className="switch__marker"><></></div>
        </div>
        <div className="right ml-2">2D</div>
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const {
      configuration,
    } = this.props;
    return configuration && configuration.result;
  }

  private dispatchConfiguration(props: ConfigurationSwitchViewDetailState) {
    if (!this.configuration) {
      return;
    }

    
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {show2d: props.show2d}
        },
      },
      true,
    ));
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    const show2d = target.checked;

    this.setState({
      show2d,
    });

    this.dispatchConfiguration({
      show2d
    });
  }

  private get show2d(): boolean { 
    if (!this.configuration) {
      return false;
    }
    return this.configuration.show2d;
  }
}

export const ConfigurationSwitchViewDetail = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration
}))(ConfigurationSwitchViewDetailPartial);

export default ConfigurationSwitchViewDetail;
